/* tslint:disable */
/* eslint-disable */
/**
 * Autom8.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {exists} from '../runtime';

/**
 *
 * @export
 * @interface TypeDefinition
 */
export interface TypeDefinition {
    /**
     *
     * @type {string}
     * @memberof TypeDefinition
     */
    name?: string | null;
    /**
     *
     * @type {string}
     * @memberof TypeDefinition
     */
    schema?: string | null;
}

export function TypeDefinitionFromJSON(json: any): TypeDefinition {
    return TypeDefinitionFromJSONTyped(json, false);
}

export function TypeDefinitionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TypeDefinition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'name': !exists(json, 'name') ? undefined : json['name'],
        'schema': !exists(json, 'schema') ? undefined : json['schema'],
    };
}

export function TypeDefinitionToJSON(value?: TypeDefinition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'name': value.name,
        'schema': value.schema,
    };
}

